import Api from './Api.service';
export default class PerfilService {
    static ObtenerTodo() {
        return Api.get('perfil');
    }
    static Insertar(model) {
        return Api.post('perfilinsertar',model);
    }
    static Editar(model) {
        return Api.put('perfileditar',model);
    }
    static Eliminar(perfilid) {
        return Api.delete(`perfil/${perfilid}`);
    }

}